import { render, staticRenderFns } from "./wdigitalchannel.vue?vue&type=template&id=b7c51130"
import script from "./wdigitalchannel.vue?vue&type=script&lang=js"
export * from "./wdigitalchannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports